import { Component, Input, OnInit } from '@angular/core';

export interface QualifiedRole {
  average_exceed: number;
  industry: string;
  match_percentage: number;
  match_score: number;
  qualification_status: string;
  role_id: string;
  role_type: string;
  requirements_met: number;
  total_requirements: number;
  requirements_details: any[];
}

export interface VersatilityData {
  industries_qualified: number;
  total_qualified_roles: number;
  versatility_score: number;
}

@Component({
  selector: 'app-qualified-roles',
  standalone: false,
  templateUrl: './qualified-roles.component.html',
  styleUrl: './qualified-roles.component.css'
})
export class QualifiedRolesComponent {
  @Input() qualifiedRolesData: any;
  @Input() versatilityData!: VersatilityData;

  topThreeRoles: QualifiedRole[] = [];
  rolesByIndustry: { [key: string]: QualifiedRole[] } = {};
  selectedIndustry: string = 'all';
  industries: string[] = [];
  displayedRoles: QualifiedRole[] = [];

  constructor() { }

  ngOnInit(): void {
    if (this.qualifiedRolesData) {
      this.topThreeRoles = this.qualifiedRolesData.overall_top_3 || [];
      this.rolesByIndustry = this.qualifiedRolesData.by_industry || {};
      this.industries = Object.keys(this.rolesByIndustry);
      this.displayedRoles = this.topThreeRoles;
    }
  }

  filterByIndustry(industry: string): void {
    this.selectedIndustry = industry;
    if (industry === 'all') {
      this.displayedRoles = this.topThreeRoles;
    } else {
      this.displayedRoles = this.rolesByIndustry[industry] || [];
    }
  }

  formatRoleType(roleType: string): string {
    return roleType.split('-').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
  }

  formatIndustry(industry: string): string {
    return industry.split('-').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
  }

}
